import {createSlice} from "@reduxjs/toolkit";

const initialUsersState = {
  listLoading: false,
  entities: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const completeDetailsSlice = createSlice({
  name: "completeDetails",
  initialState: initialUsersState,
  reducers: {
    completeDetailsFetched: (state, action) => {
      const {entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.completeDetailsError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
